document.addEventListener('DOMContentLoaded', function() {

  // אובייקט ההגדרות שלנו עם תגיות HTML להדגשה וקו תחתון
  const plans = [
    { id: '2694578332', text: 'רכשו מנוי וקבלו משלוח בכל <u><strong>30 ימים</strong></u>' },
    { id: '2694611100', text: 'רכשו מנוי וקבלו משלוח בכל <u><strong>90 ימים</strong></u>' },
    { id: '2703655068', text: 'רכשו מנוי וקבלו משלוח בכל <u><strong>150 ימים</strong></u>' }
  ];

  // הפונקציה המרכזית שמעדכנת את Appstle לפי הבאנדל שנבחר
  function syncBundleWithAppstle(activeBundleElement) {
    if (!activeBundleElement) return;

    const allBundles = Array.from(document.querySelectorAll('.ab-volume-discount-item-container-v2'));
    const bundleIndex = allBundles.indexOf(activeBundleElement);
    const targetPlan = plans[bundleIndex];

    if (targetPlan) {
      // 1. עדכון הטקסט החזותי של Appstle באמצעות innerHTML
      const subscriptionTextLabel = document.querySelector('.appstle_single_option_text');
      if (subscriptionTextLabel) {
        subscriptionTextLabel.innerHTML = targetPlan.text; // <--- השינוי כאן
      }

      // 2. עדכון הערך של ה-Selling Plan שנשלח לעגלה
      const appstleSelectDropdown = document.querySelector('.appstle_sub_widget select, [name="selling_plan"]');
      if (appstleSelectDropdown && appstleSelectDropdown.value !== targetPlan.id) {
        return;
        appstleSelectDropdown.value = targetPlan.id;
        appstleSelectDropdown.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  // === מנגנון 1: טיפול בטעינה הראשונית (אסינכרונית) ===
  const initInterval = setInterval(() => {
    const textLabel = document.querySelector('.appstle_single_option_text');
    const selectedBundle = document.querySelector('.ab-volume-discount-item-selected-v2'); 
    
    if (textLabel && selectedBundle) {
      syncBundleWithAppstle(selectedBundle);
      clearInterval(initInterval);
    }
  }, 500);

  setTimeout(() => clearInterval(initInterval), 10000);

  // === מנגנון 2: טיפול בלחיצות של המשתמש ===
  document.addEventListener('click', function(event) {
    const clickedBundle = event.target.closest('.ab-volume-discount-item-container-v2');
    if (clickedBundle) {
      setTimeout(() => {
        syncBundleWithAppstle(clickedBundle);
      }, 50);
    }
  });

});